import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TrendingUp, Target, DollarSign, Clock,
  BarChart3, Award, Zap, ChevronDown, ChevronUp
} from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatCurrency(val) {
  if (!val) return "$0";
  if (val >= 1e6) return `$${(val / 1e6).toFixed(1)}M`;
  if (val >= 1e3) return `$${(val / 1e3).toFixed(0)}K`;
  return `$${val.toFixed(0)}`;
}

export default function LenderMetricsPanel() {
  const [metrics, setMetrics] = useState(null);
  const [expanded, setExpanded] = useState(true);
  const token = localStorage.getItem("ic_token");

  useEffect(() => {
    axios.get(`${API}/portal/lender/metrics`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setMetrics(r.data))
      .catch(() => {});
  }, []);

  if (!metrics) return null;

  const cards = [
    { icon: Target, label: "Response Rate", value: `${metrics.response_rate}%`, sub: `${metrics.interests_expressed} of ${metrics.total_deals_visible} deals`, color: "emerald" },
    { icon: Award, label: "Win Rate", value: `${metrics.win_rate}%`, sub: `${metrics.term_sheets_selected} won / ${metrics.term_sheets_submitted} quoted`, color: "blue" },
    { icon: DollarSign, label: "Volume Won", value: formatCurrency(metrics.total_won_volume), sub: `${formatCurrency(metrics.total_quoted_volume)} total quoted`, color: "amber" },
    { icon: Clock, label: "Avg Response", value: metrics.avg_response_days > 0 ? `${metrics.avg_response_days}d` : "—", sub: "avg days to respond", color: "purple" },
  ];

  return (
    <div className="rounded-2xl bg-white border border-[#EDE8DC] overflow-hidden shadow-[0_2px_20px_rgba(0,0,0,0.03)]" data-testid="lender-metrics-panel">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-5 py-3.5 hover:bg-[#FDFCF9] transition-colors"
      >
        <div className="flex items-center gap-2">
          <BarChart3 className="h-4 w-4 text-emerald-600" />
          <span className="text-sm font-bold text-[#0A0A0A] tracking-tight">My Activity</span>
        </div>
        {expanded ? <ChevronUp className="h-4 w-4 text-[#bbb]" /> : <ChevronDown className="h-4 w-4 text-[#bbb]" />}
      </button>
      {expanded && (
        <div className="px-5 pb-5">
          <div className="grid grid-cols-2 gap-3">
            {cards.map((card) => (
              <div key={card.label} className="rounded-xl bg-[#FDFCF9] border border-[#f0ece4] p-3" data-testid={`lender-metric-${card.label.toLowerCase().replace(/\s/g, "-")}`}>
                <div className="flex items-center gap-1.5 mb-1">
                  <card.icon className={`h-3 w-3 text-${card.color}-600`} />
                  <span className="text-[9px] uppercase tracking-[0.1em] text-[#888] font-bold">{card.label}</span>
                </div>
                <p className="text-lg font-bold text-[#0A0A0A] tracking-tight">{card.value}</p>
                <p className="text-[9px] text-[#bbb] mt-0.5">{card.sub}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
